import { request } from '../request'

/**
 * 获取线下面访列表
 * @param id 问卷ID
 * @param params
 * @return {Promise}
 */
export const getOfflineList = params => {
  return request({
    method: 'get',
    url: '/quota/surveyJobExecution/list',
    params
  })
  // return request.get("/quota/surveyJobExecution/list/" + id,params)
}
/**
 * 获取样本任务列表
 * @param id 问卷ID
 * @return {Promise}
 */
// export const getOfflineSampleList = (id) => {
//   return request.get("/quota/surveyJobExecution/sampleList/" + id)
// }
export const getOfflineSampleList = params => {
  return request({
    url: '/quota/surveyJobExecution/sampleList/',
    method: 'get',
    params: params
  })
}
/**
 * 分配任务
 * @param data
 * @return {Promise}
 */
export const postAssignSampleOfflineTask = data => {
  return request.post('/quota/surveyJobExecution/addSample', data)
}
/**
 * 查看面对面访问任务
 * @param id 任务ID
 * @return {Promise}
 */
export const getShowOfflineTask = id => {
  return request.get('/quota/surveyJobExecution/' + id)
}
/**
 * 结算任务
 * @param id 任务ID
 * @return {Promise}
 */
export const getSettlementOfflineTask = id => {
  return request.get('/quota/surveyJobExecution/' + id)
}

/**
 * 分配任务
 * @param data
 * @return {Promise}
 */
export const postAssignOfflineTask = data => {
  return request.post('/quota/surveyJobExecution', data)
}
/**
 * 检查调查员手机
 * @param phone
 * @return {Promise}
 */
export const getCheckPhone = phone => {
  return request.get('/quota/surveyJobExecution/check/' + phone)
}

/**
 * 编辑任务
 * @param data
 * @return {void|AxiosPromise<any>|IDBRequest<IDBValidKey>|Promise<void>}
 */
export const putOfflineTask = data => {
  return request.put('/quota/surveyJobExecution', data)
}

/**
 * 任务开关
 */
export const putOfflineTaskSwitch = data => {
  return request.put('/quota/surveyJobExecution/batchOpenOrClose', data)
}

/**
 * 结算任务
 * @param data{id:String}
 * @return {void|AxiosPromise<any>|IDBRequest<IDBValidKey>|Promise<void>}
 */
export const settlementTask = data => {
  return request.put('/quota/surveyJobExecution/settle', data)
}

/**
 * 结算督导吧任务
 * @param data
 * @return {Promise}
 */
export const settleJob = data => {
  return request.post('/quota/surveyJob/settleJob', data)
}

export const changeOfflineStatus = () => {}

// 查询随机面访任务分页列表（新）
export const getRandomInterviewTableData = params => {
  return request({
    url: `/quota/surveyJobExecution/jobExecutionPage`,
    params: params,
    methods: 'GET'
  })
}
// 查询待承接调查员分页列表（新）
export const getEntrustInterviewTableData = params => {
  return request({
    url: `/quota/surveyJobExecution/list4EntrustForMyEntrust`,
    params: params,
    methods: 'GET'
  })
}

// 新增招募任务
export function addRecruitTask(data) {
  return request({
    url: '/quota/surveyJobExecution/recruitTask',
    method: 'post',
    data
  })
}

// 修改招募任务
export function editRecruitTask(data) {
  return request({
    url: '/quota/surveyJobExecution/recruitTask',
    method: 'put',
    data
  })
}

// 查询招募任务明细
export function getRecruitTaskDetail(params) {
  return request({
    url: '/quota/surveyJobExecution/recruitTaskDetail',
    method: 'get',
    params
  })
}

// 查询招募任务列表
export function getRecruitTaskList(params) {
  return request({
    url: '/quota/surveyJobExecution/recruitTaskList',
    method: 'GET',
    params
  })
}
//批量创建面对面访问任务（新）
export function newAddList(params) {
  return request({
    url: '/quota/surveyJobExecution/newAddList',
    method: 'post',
    data: params
  })
}

//手机号查询调查员
export function interviewerListByPhone(params) {
  return request({
    url: '/quota/wjInvestigator/interviewerListByPhone',
    method: 'post',
    data: params
  })
}

//查询调查员库
export function interviewerList(params) {
  return request({
    url: '/quota/wjInvestigator/pageInvestigatorByNameAndPhone',
    method: 'get',
    params: params
  })
}

// 关闭招募任务
export function closeRecruitTask(id) {
  return request({
    url: `/quota/surveyJobExecution/closeRecruitTask?id=${id}`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 淘汰报名的调查员
export function weedOutInterviewer(data) {
  return request({
    url: '/quota/surveyJobExecution/weedOut',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 获取招募任务调查员信息 用于条件筛选查询
export function getRecruitTaskInterviewersInfo(params) {
  return request({
    url: '/quota/surveyJobExecution/recruitTaskInterviewers',
    method: 'GET',
    params
  })
}

// 批量创建面访任务 新接口 用于创建招募任务 多了一个招募任务id字段 用于绑定关系
export function createFaceToFaceWorkNew(data) {
  return request({
    url: '/quota/surveyJobExecution/newAddList',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 新增招募代理任务
export function addAgencyTask(data) {
  return request({
    url: '/quota/surveyJobExecution/agencyTask',
    method: 'post',
    data
  })
}

// 修改招募代理任务
export function editAgencyTask(data) {
  return request({
    url: '/quota/surveyJobExecution/agencyTask',
    method: 'put',
    data
  })
}

// 查询招募代理任务明细
export function getAgencyTaskDetail(params) {
  return request({
    url: '/quota/surveyJobExecution/agencyTaskDetail',
    method: 'get',
    params
  })
}

// 查询代理招募任务列表(委托代理)
export function getAgencyTaskList(params) {
  return request({
    url: '/quota/surveyJobExecution/agencyTaskList',
    method: 'GET',
    params
  })
}

// 查询代理招募任务代理列表（委托代理 条件查询使用）
export function getAgencyTaskAgents(params) {
  return request({
    url: '/quota/surveyJobExecution/agencyTaskAgents',
    method: 'GET',
    params
  })
}

// 淘汰代理
export function agencyWeedOut(data) {
  return request({
    url: '/quota/surveyJobExecution/agencyWeedOut',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 关闭代理招募
export function closeAgencyTask(params) {
  return request({
    url: `/quota/surveyJobExecution/closeAgencyTask?id=${params.id}`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-ww-form-urlencoded'
    }
  })
}

//查询代理库
export function agencyListProxy(params) {
  return request({
    url: '/quota/surveyJobExecution/agencyList',
    method: 'get',
    params
  })
}

// 批量创建委托代理任务
export function batchAddProxyTask(data) {
  return request({
    // url: '/quota/wjentrusttask/addList',
    url: '/quota/wjentrusttask/addListForEntrust',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

/**
 * 批量开启关闭 随机面坊任务
 * @param id 任务ID
 * @return {Promise}
 */
export const getOpenAndCloseTaskAPI = params => {
  return request({
    url: '/quota/surveyJobExecution/setOpenTask',
    method: 'post',
    data: params
  })
}

// 列表查询excel导出
export const jobExecutionExcel = params => {
  return request({
    url: '/quota/surveyJobExecution/jobExecutionExcel',
    method: 'get',
    params: params
  })
}

// 样本相关接口
export const getSampleGroupInfoByGroupType = params => {
  return request({
    url: '/wjsample/wjsamplegroupnew/getSampleGroupInfoByGroupType',
    method: 'get',
    params: params
  })
}
export const getSampleHeader = params => {
  return request({
    url: '/wjsample/wjsampleans/header',
    method: 'get',
    params: params
  })
}
export const getSampleAnsPage = params => {
  return request({
    url: '/wjsample/wjsampleans/filterWjSampleAnsPage',
    method: 'post',
    data: params
  })
}
export const hasSampleAns = params => {
  return request({
    url: '/wjsample/wjsampleans/hasSampleAns',
    method: 'get',
    params: params
  })
}
export const wjsamplegroupnewGetById = id => {
  return request({
    url: `/wjsample/wjsampleans/getSurveyByGroupId`,
    method: 'get',
    params: {
      groupId:id
    }
  })
}
export const wjsampleShowFields = params => {
  return request({
    url: `/wjsample/wjsampleans/showFields`,
    method: 'get',
    params
  })
}
// 保存添加样本
export const saveSampleAnsIdsForSms = data => {
  return request({
    url: `/wjsample/wjsampleans/saveSampleAnsIdsForSms`,
    method: 'post',
    data
  })
}
// 删除已添加样本
export const removeSampleAnsForSms = data => {
  return request({
    url: `/wjsample/wjsampleans/removeSampleAnsForSms`,
    method: 'post',
    data
  })
}
// 保存添加样本
export const getSampleAnsForSms = params => {
  return request({
    url: `/wjsample/wjsampleans/getSampleAnsForSms`,
    method: 'get',
    params
  })
}

